import React, { useCallback, useRef, useState } from 'react';
import { useOnDismiss } from '../hooks/useOnDismiss';
import { cx } from '../utils/cx';

export function Dropdown({label, value, options, disabled, onChange}) {
    const target = useRef(null);

    const [isOpen, setIsOpen] = useState(false);

    useOnDismiss(
        target,
        isOpen,
        useCallback(() => setIsOpen(false), [setIsOpen]),
    );

    function _onChange(value) {
        setIsOpen(false);
        onChange(value);
    }

    return (
        <div
            className="relative basis-full sm:basis-[calc(50%_-_6px)] md:flex-1"
            ref={target}
        >
            <button
                className={cx(
                    'w-full p-3 flex-1 flex items-center justify-between gap-x-3 text-xs font-medium whitespace-nowrap border border-primary rounded',
                    isOpen && '!rounded-none !rounded-t',
                )}
                onClick={() => setIsOpen(!isOpen)}
            >
                {label}
                <i
                    className={cx(
                        'icon-chevron text-[16px]',
                        isOpen && 'rotate-180',
                    )}
                ></i>
            </button>
            {isOpen &&
                <div
                    className={cx(
                        'absolute z-[1] top-full w-full bg-white rounded-b border border-primary shadow-md',
                        isOpen && '!border-t-0',
                    )}
                >
                    {options.map((o, i) => {
                        return (
                            <label key={i} className="radio !rounded-none w-full has-[:checked]:bg-primary/20">
                                <input
                                    className="peer"
                                    type="radio"
                                    checked={value === o.value}
                                    disabled={disabled}
                                    onChange={e => _onChange(i)}
                                />
                                <span className="after:bg-primary peer-checked:before:border-primary">{o.label}</span>
                            </label>
                        );
                    })}
                </div>
            }
        </div>
    );
}
